// extracted by mini-css-extract-plugin
export default {"container":"toggle_container__vB0nk","tab":"toggle_tab__eLVph","tab1":"toggle_tab1__h25KJ","tab2":"toggle_tab2__WbliD"};